module.exports = __webpack_public_path__ + "img/grey-usefull.3a3bdc44.png";